import React, { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import {
  Container,
  GridItem,
  Flex,
  Text,
  Box,
  VStack,
  HStack
} from '@chakra-ui/react'
import { useExperienceManager } from '@hooks'
import { LayoutGrid } from '@blueprinthq/joy'
import { endpoints } from '@api'
import { useHistory } from 'react-router-dom'

import { UploadModal } from '../sessions/components'
import { MicAIOn, Upload } from '@components/icons'
import { ConsentModule, SampleSessionsModule } from './components'

export const SessionGetStarted = () => {
  const { isAdmin, isDocumentationAutomationEnabled } = useExperienceManager()
  const [uploadModalOpen, setUploadModalOpen] = useState(false)
  const history = useHistory()

  const { data: user } = useQuery(
    endpoints.getUserAccount.getCacheId(),
    endpoints.getUserAccount.request
  )

  useEffect(() => {
    if (!isDocumentationAutomationEnabled) {
      history.replace('/sessions')
    }
  }, [isDocumentationAutomationEnabled])

  if (!user) return null

  return (
    <Container mt={'24px'}>
      <LayoutGrid>
        <GridItem
          colSpan={{
            base: 12,
            sm: 6,
            md: 6
          }}
          colStart={{
            base: 0,
            sm: 2,
            md: 4
          }}
        >
          <Flex
            direction="column"
            align="space-between"
            justify="center"
            mb={6}
          >
            <Text as="h1" fontSize="lg" fontWeight="bold">
              {`Hi ${user?.first_name}, let's get started`}
            </Text>
            <Text>Choose from the options below to get started</Text>
          </Flex>
          <Box
            id="pendo-sessions-get-started-start-session"
            onClick={() =>
              history.push('/start-session/select-client?signup=true')
            }
            _hover={{ cursor: 'pointer', background: '#F7F8F9' }}
            p="small"
            width="100%"
            borderRadius="8px"
            border="1px solid #E4E5E6"
            mb="small"
          >
            <HStack spacing={3}>
              <Box h="36px" w="36px">
                <MicAIOn fill="#4366EA" height="36px" width="36px" />
              </Box>
              <VStack spacing={0} alignItems="flex" justifyContent="flex-start">
                <Text fontWeight="bold">Record a session</Text>
                <Text>
                  Record a client session to auto-generate clinical notes
                </Text>
              </VStack>
            </HStack>
          </Box>
          <Box
            id="pendo-sessions-get-started-upload-session"
            onClick={() => setUploadModalOpen(true)}
            _hover={{ cursor: 'pointer', background: '#F7F8F9' }}
            p="small"
            width="100%"
            borderRadius="8px"
            border="1px solid #E4E5E6"
            mb="small"
          >
            <HStack spacing={3}>
              <Box h="36px" w="36px">
                <Upload fill="#4366EA" height="36px" width="36px" />
              </Box>
              <VStack spacing={0} alignItems="flex" justifyContent="flex-start">
                <Text fontWeight="bold">Upload a recording</Text>
                <Text>Generate a note using an audio recording</Text>
              </VStack>
            </HStack>
          </Box>
          <Box mb="medium">
            <SampleSessionsModule isGetStarted />
          </Box>
          {isAdmin && <ConsentModule isGetStarted />}
        </GridItem>
      </LayoutGrid>
      <UploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
      />
    </Container>
  )
}
